
import { computed, defineComponent, ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
import { sexType } from "@/const/character";
export default defineComponent({
  setup(props, ctx) {
    const { sex, characterIndex } = store.state.userInfo;
    const characterV = ref(characterIndex);
    const sexV = ref(sexType[sex]);
    //最大生命值
    const HPV = computed(() => {
      return store.getters.playerBattleProperty.HP;
    });
    //当前生命值
    const CHPV = computed(() => {
      return store.getters.userPropertyCHP;
    });
    //当前生命值比率
    const CHPP = computed(() => {
      let P = Math.ceil((CHPV.value / HPV.value) * 100);
      if (P < 0) {
        P = 0;
      } else if (P > 100) {
        P = 100;
      }
      if (P <= 40) {
        ctx.emit("handledanger", true);
      } else {
        ctx.emit("handledanger", false);
      }
      return P;
    });
    const username = ref(store.state.userInfo.userName);
    return {
      characterV,
      sexV,
      HPV,
      CHPV,
      CHPP,
      username
    };
  }
});
